import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TenantHelper } from '@shared/features/tenant/shared/helpers/tenant.helper';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { TenancyContext } from '@core/tenancy';
import { APP_ROUTES_SEGMENTS } from '@app/core/enums/app-routes-segments.enum';
import { ProbateStartNavigationService } from '@app/probate/features/start/services/probate-start-navigation.service';
import { GuardianshipStartNavigationService } from '@app/guardianship/features/start/services/guardianship-start-navigation.service';
import { MinorStartNavigationService } from '@app/minor-estates/features/start/services/minor-start-navigation.service';
import { TrustStartNavigationService } from '@app/trust/features/start/services/trust-start-navigation.service';

@Injectable({ providedIn: 'root' })
export class ApplicationRoutingService {
  private _router = inject(Router);
  private readonly _tenancy = inject(TenancyContext);
  private readonly _startNavigationService = inject(
    ProbateStartNavigationService,
  );
  private readonly _guardianshipStartNavigationService = inject(
    GuardianshipStartNavigationService,
  );
  private readonly _minorEstateStartNavigationService = inject(
    MinorStartNavigationService,
  );
  private readonly _trustStartNavigationService = inject(
    TrustStartNavigationService,
  );

  startNewApplication(tenantType: TenantKey) {
    if (tenantType === TenantKey.PROBATE) {
      return this._startNavigationService.goToConfirmation();
    }

    const tenant = TenantHelper.getTenantByType(tenantType);

    if (!tenant) {
      return this._router.navigate([
        this._tenancy.link(APP_ROUTES_SEGMENTS.wip),
      ]);
    }

    if (tenant.key === TenantKey.GUARDIANSHIP) {
      return this._guardianshipStartNavigationService.goToConfirmation();
    }
    if (tenant.key === TenantKey.MINOR) {
      return this._minorEstateStartNavigationService.goToResidencyConfirmation();
    }
    if (tenant.key === TenantKey.TRUST) {
      return this._trustStartNavigationService.goToAccount();
    }

    return this._router.navigate([this._tenancy.link(APP_ROUTES_SEGMENTS.wip)]);
  }
}
